import { render } from "./DynamicTable2_dynamic_column.vue?vue&type=template&id=5a8bf80a&scoped=true"
import script from "./DynamicTable2_dynamic_column.vue?vue&type=script&lang=js"
export * from "./DynamicTable2_dynamic_column.vue?vue&type=script&lang=js"

import "./DynamicTable2_dynamic_column.vue?vue&type=style&index=0&id=5a8bf80a&lang=scss&scoped=true"

import exportComponent from "../../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8bf80a"]])

export default __exports__